import React, { useEffect } from "react";
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";
import "./styles/globals.css";

const App = () => {
  useEffect(() => {
    const i18nlocale = localStorage.getItem("i18nextLng");
    if (i18nlocale) {
      // locale handling preserved for future i18n needs
    }
  }, []);

  return <Routes />;
};

export default App;
